import request from '../utils/request'
// 获取管理办法
export function getData(data) {
	return request({
		url: '/api/agreement/getData',
		method: 'post',
		data
	})
}
// 获取活动列表
export function getActivityList(data) {
	return request({
		url: '/api/user/getActivityList',
		method: 'post',
		data
	})
}
// 活动详情
export function activityInfo(data) {
	return request({
		url: '/api/user/activityInfo',
		method: 'post',
		data
	})
}
// 立即报名
export function joinActivity(data) {
	return request({
		url: '/api/user/joinActivity',
		method: 'post',
		data
	})
}
// 扫码签到
export function signIn(data) {
	return request({
		url: '/api/User/signIn',
		method: 'post',
		data
	})
}
// 省市区
export function getAddressList(data) {
	return request({
		url: '/api/Agreement/getAddressList',
		method: 'post',
		data
	})
}
// 申请表
export function userApply(data) {
	return request({
		url: '/api/user/userApply',
		method: 'post',
		data
	})
}
// 申请表
export function getUserServerList(data) {
	return request({
		url: '/api/user/getUserServerList',
		method: 'post',
		data
	})
}
// 点击查看证书
export function lookCert(data) {
	return request({
		url: '/api/user/lookCert',
		method: 'post',
		data
	})
}
